(function () {
  var FORM_SELECTOR = '#la-prescription-form';
  var ENHANCED_MARKER = '.ciw-la-contact-rx-card';
  var MQ_MOBILE = window.matchMedia('(max-width: 749px)');
  var contactLaActiveStep = null;

  var CONTACT_FIELD_ORDER = ['sph', 'bc', 'dia', 'cyl', 'axis', 'add'];
  var CONTACT_RX_KEYS = ['sph', 'cyl', 'axis', 'base_curve', 'diameter', 'add'];

  var ROW_PRIMARY = [
    { slot: 'sph', name: 'POWER', acronym: '' },
    { slot: 'bc', name: 'BC', acronym: '' },
    { slot: 'dia', name: 'DIA', acronym: '' }
  ];

  var ROW_SECONDARY = [
    { slot: 'cyl', name: 'CYL', acronym: '' },
    { slot: 'axis', name: 'AXIS', acronym: '' }
  ];

  var CONTACT_DESKTOP_COLUMNS = ROW_PRIMARY.concat(ROW_SECONDARY);

  function getContactLayoutMode(form) {
    if (isMobile()) return 'mobile';
    form = form || getContactForm();
    if (!form) return 'desktop-sphere-stack';
    var eyes = findEyeContainers(form);
    if (!eyes) return 'desktop-sphere-stack';
    if (contactUsesDesktopGrid(getRxItems(eyes.right), getRxItems(eyes.left))) {
      return 'desktop-toric-grid';
    }
    return 'desktop-sphere-stack';
  }

  function isMobile() {
    return MQ_MOBILE.matches;
  }

  function contactUsesDesktopGrid(rightItems, leftItems) {
    if (isMobile()) return false;
    var used = new Set();
    return !!(findItemBySlot(rightItems, 'cyl', used) || findItemBySlot(leftItems, 'cyl', new Set()));
  }

  function isContactHost() {
    return window.ciwLaHostApi ? window.ciwLaHostApi.isContactLens() : !!document.querySelector('.cl-section');
  }

  function getContactContentBody(form) {
    form = form || getContactForm();
    if (!form) {
      return document.querySelector(
        '#lensadvizor-prescription-modal .la-prescription-modal-content-body'
      );
    }
    return form.closest('.la-prescription-modal-content-body');
  }

  function hideContactManualRxContentBodyForEnhance() {
    if (!isMobile() || !isContactHost()) return;
    var contentBody = getContactContentBody();
    if (!contentBody) return;
    contentBody.style.setProperty('visibility', 'hidden', 'important');
    contentBody.setAttribute('data-ciw-la-contact-rx-pending', '1');
  }

  function revealContactManualRxContentBodyAfterEnhance(form) {
    if (!isMobile() || !isContactHost()) return;
    form = form || getContactForm();
    if (!form || !form.classList.contains('ciw-la-contact-rx-form--ready')) return;
    var contentBody = getContactContentBody(form);
    if (!contentBody || contentBody.getAttribute('data-ciw-la-contact-rx-pending') !== '1') return;
    contentBody.style.removeProperty('visibility');
    contentBody.removeAttribute('data-ciw-la-contact-rx-pending');
  }

  function clearContactManualRxContentBodyPendingHide() {
    var contentBody = document.querySelector(
      '#lensadvizor-prescription-modal .la-prescription-modal-content-body[data-ciw-la-contact-rx-pending]'
    );
    if (!contentBody) return;
    contentBody.style.removeProperty('visibility');
    contentBody.removeAttribute('data-ciw-la-contact-rx-pending');
  }

  function isContactFormStep() {
    if (!isContactHost()) return false;

    if (document.querySelector('.la-quantity-selector-wrapper')) {
      return true;
    }

    var form = getContactForm();
    if (!form) return false;

    return hasContactRxFieldItems(form) || !!document.querySelector('.la-contact-lenswrapper');
  }

  function getContactForm() {
    return document.querySelector(FORM_SELECTOR);
  }

  function containerHasRxItems(container) {
    if (!container) return false;
    return getRxItems(container).length > 0;
  }

  function findEyeContainers(form) {
    if (!form) return null;

    var right = form.querySelector('.la-right-rx-container');
    var left = form.querySelector('.la-left-rx-container');
    if (right && left) {
      return { right: right, left: left };
    }

    right =
      form.querySelector('[data-eye="od_right"], [data-eye="od"], #od_right, .la-od-rx-container, .od-rx-container');
    left =
      form.querySelector('[data-eye="os_left"], [data-eye="os"], #os_left, .la-os-rx-container, .os-rx-container');
    if (right && left) {
      return { right: right, left: left };
    }

    var wrappers = Array.from(form.querySelectorAll('.la-prescription-fields-wrapper')).filter(function (wrapper) {
      return !wrapper.closest('.la-upload-wrapper, .la-quantity-selector-wrapper, .ciw-la-contact-rx-card');
    });
    var od = null;
    var os = null;

    wrappers.forEach(function (wrapper) {
      var heading = wrapper.querySelector('.la-h6, h6, .la-eye-title, .la-wrapper-heading, label');
      var text = heading ? heading.textContent.toLowerCase() : '';
      var marker = (wrapper.className + ' ' + (wrapper.id || '') + ' ' + wrapper.innerHTML).toLowerCase();
      if (!od && (text.indexOf('od') >= 0 || text.indexOf('right') >= 0 || marker.indexOf('od_right') >= 0)) {
        od = wrapper;
      } else if (!os && (text.indexOf('os') >= 0 || text.indexOf('left') >= 0 || marker.indexOf('os_left') >= 0)) {
        os = wrapper;
      }
    });

    if (od && os) {
      return { right: od, left: os };
    }

    var rxWrappers = wrappers.filter(containerHasRxItems);
    if (rxWrappers.length >= 2) {
      return { right: rxWrappers[0], left: rxWrappers[1] };
    }

    var fieldsWrapper = form.querySelector('.la-fields-wrapper');
    if (fieldsWrapper) {
      var blocks = Array.from(fieldsWrapper.children).filter(function (child) {
        return (
          child !== form.querySelector(ENHANCED_MARKER) &&
          !child.classList.contains('ciw-la-contact-rx-card') &&
          !child.classList.contains('ciw-la-manual-rx-heading') &&
          containerHasRxItems(child)
        );
      });
      if (blocks.length >= 2) {
        return { right: blocks[0], left: blocks[1] };
      }
    }

    return null;
  }

  function getRxItems(container) {
    if (!container) return [];

    return Array.from(container.querySelectorAll('.la-form-item[key]')).filter(function (item) {
      return (
        !item.closest('.la-quantity-selector-wrapper, .la-upload-wrapper, .ciw-la-contact-rx-card') &&
        !item.classList.contains('ciw-la-manual-rx-hidden')
      );
    });
  }

  function getSelectLabelText(select) {
    if (!select) return '';

    var item = select.closest('.la-form-item, .la-form-flex, .la-prescription-fields-wrapper');
    if (item) {
      var label = item.querySelector('label');
      if (label) return label.textContent;
    }

    var prev = select.previousElementSibling;
    if (prev && /label|span|p|th|td/i.test(prev.tagName)) {
      return prev.textContent;
    }

    return '';
  }

  function normalizeFieldName(name, labelText) {
    var normalized = String(name || '')
      .toLowerCase()
      .replace(/[\s_\[\].]+/g, '');
    var label = String(labelText || '').toLowerCase().trim();

    if (!normalized && !label) return '';

    if (
      normalized === 'sph' ||
      normalized === 'sphere' ||
      normalized === 'power' ||
      normalized.indexOf('sphere') >= 0 ||
      normalized.indexOf('power') >= 0 ||
      label.indexOf('sph') >= 0 ||
      label.indexOf('power') >= 0
    ) {
      return 'sph';
    }
    if (normalized === 'cyl' || normalized === 'cylinder' || normalized.indexOf('cylinder') >= 0 || label.indexOf('cyl') >= 0) {
      return 'cyl';
    }
    if (normalized === 'axis' || normalized.indexOf('axis') >= 0 || label.indexOf('axis') >= 0) {
      return 'axis';
    }
    if (
      normalized === 'bc' ||
      normalized === 'basecurve' ||
      normalized.indexOf('basecurve') >= 0 ||
      normalized.indexOf('base') >= 0 ||
      label.indexOf('base curve') >= 0 ||
      label === 'bc'
    ) {
      return 'bc';
    }
    if (
      normalized === 'dia' ||
      normalized === 'diameter' ||
      normalized.indexOf('diameter') >= 0 ||
      normalized.indexOf('diam') >= 0 ||
      label.indexOf('diameter') >= 0 ||
      label === 'dia'
    ) {
      return 'dia';
    }
    if (normalized === 'add' || normalized.indexOf('add') >= 0 || label.indexOf('add') >= 0) {
      return 'add';
    }

    return normalized;
  }

  function getItemSlot(item) {
    if (!item) return '';

    var key = item.getAttribute('key');
    if (key) {
      if (key === 'base_curve') return 'bc';
      if (key === 'diameter') return 'dia';
      return key;
    }

    var field = item.querySelector('[data-field-name]');
    var fieldName = field && field.getAttribute('data-field-name');
    if (!fieldName) {
      var select = item.querySelector('select');
      fieldName = select ? select.getAttribute('data-field-name') || select.name || select.id || '' : '';
    }

    var label = item.querySelector('label');
    return normalizeFieldName(fieldName, label ? label.textContent : '');
  }

  function findItemBySlot(items, slot, usedItems) {
    usedItems = usedItems || new Set();

    var matched =
      items.find(function (item) {
        return !usedItems.has(item) && getItemSlot(item) === slot;
      }) || null;
    if (matched) return matched;

    var available = items.filter(function (item) {
      return !usedItems.has(item);
    });
    var idx = CONTACT_FIELD_ORDER.indexOf(slot);
    if (idx >= 0 && idx < available.length) {
      return available[idx];
    }

    return null;
  }

  function itemHasControl(item) {
    if (!item) return false;
    return !!item.querySelector('.la-form-select, select, input.la-form-input');
  }

  function itemHasDropdown(item) {
    if (!item) return false;
    return !!item.querySelector('.la-form-select, select');
  }

  function hasContactRxFieldItems(form) {
    form = form || getContactForm();
    if (!form) return false;

    return Array.from(form.querySelectorAll('.la-prescription-fields-wrapper .la-form-item[key]')).some(function (item) {
      return CONTACT_RX_KEYS.indexOf(item.getAttribute('key')) >= 0;
    });
  }

  function isContactManualEntryStep(form) {
    form = form || getContactForm();
    if (!form) return false;
    if (contactLaActiveStep === 'upload') return false;
    if (form.querySelector('.la-right-rx-container') || form.querySelector('.la-left-rx-container')) {
      return true;
    }

    return hasContactRxFieldItems(form);
  }

  function isContactUploadStep(form) {
    form = form || getContactForm();
    if (!form) return false;
    if (contactLaActiveStep === 'manual') return false;
    if (contactLaActiveStep === 'upload') {
      return !!form.querySelector('.la-upload-wrapper');
    }
    if (isContactManualEntryStep(form)) return false;
    return !!form.querySelector('.la-upload-wrapper');
  }

  function isConfirmNodeInsideQuantity(node) {
    return !!(node && node.closest('.la-quantity-selector-wrapper, .ciw-la-contact-quantity'));
  }

  function hideElement(el) {
    if (!el) return;
    if (
      el.closest('.ciw-la-contact-rx-card') &&
      !el.closest('.ciw-la-rx-grid__col-field label') &&
      !isConfirmNodeInsideQuantity(el)
    ) {
      return;
    }
    el.classList.add('ciw-la-manual-rx-hidden');
  }

  function revealElement(el) {
    if (!el) return;
    el.classList.remove('ciw-la-manual-rx-hidden');
  }

  function revealContactCardContents(card) {
    if (!card) return;
    revealElement(card);

    card.querySelectorAll('.ciw-la-manual-rx-hidden').forEach(function (node) {
      if (node.classList.contains('ciw-la-contact-native-stale')) return;
      if (node.closest('.la-left-rx-container, .la-right-rx-container')) return;
      if (node.closest('.ciw-la-rx-grid__col-field') && node.tagName === 'LABEL') return;
      if (isConfirmNodeInsideQuantity(node)) return;
      if (
        node.matches('.ciw-la-manual-rx-confirm-row, .la-checkox-wrapper-label, label') &&
        node.querySelector('input[type="checkbox"]') &&
        isContactPrescriptionConfirmCheckbox(node.querySelector('input[type="checkbox"]'))
      ) {
        return;
      }
      revealElement(node);
    });

    card.querySelectorAll(
      '.ciw-la-manual-rx-section--rx, .ciw-la-rx-stack--mobile, .ciw-la-rx-eye-block, .ciw-la-rx-grid, .ciw-la-rx-grid__col, .ciw-la-rx-grid__col-field, .la-form-item, .la-form-select, select, input.la-form-input'
    ).forEach(revealElement);
  }

  function eyeItemsAreReady(items) {
    if (!items || !items.length) return false;

    var sphItem = findItemBySlot(items, 'sph');
    if (!sphItem || !itemHasDropdown(sphItem)) return false;

    return items.filter(itemHasControl).length >= 3;
  }

  function buildColumnHead(column) {
    var head = document.createElement('div');
    head.className = 'ciw-la-rx-grid__col-head';

    var name = document.createElement('span');
    name.className = 'ciw-la-rx-grid__col-name';
    name.textContent = column.name;

    head.appendChild(name);

    if (column.acronym) {
      var acronym = document.createElement('span');
      acronym.className = 'ciw-la-rx-grid__col-acronym';
      acronym.textContent = column.acronym;
      head.appendChild(acronym);
    }

    return head;
  }

  function getItemControlHost(item) {
    if (!item) return null;
    return item.querySelector('.la-form-select') || item;
  }

  function appendItemToCell(cell, item, restoreMap) {
    if (!item) return null;

    hideElement(item.querySelector('label'));

    var wrap = item.querySelector('.ciw-la-rx-select');
    if (wrap) {
      if (restoreMap && !restoreMap.has(wrap)) {
        restoreMap.set(wrap, { anchor: item, parent: wrap.parentElement });
      }
      cell.appendChild(wrap);
      return wrap;
    }

    var select = item.querySelector('select, input.la-form-input');
    if (select) {
      if (restoreMap && !restoreMap.has(select)) {
        restoreMap.set(select, { anchor: item, parent: select.parentElement });
      }
      cell.appendChild(select);
      return select;
    }

    return null;
  }

  function restoreItemsFromCard(card, restoreMap) {
    if (!card || !restoreMap) return;

    restoreMap.forEach(function (meta, control) {
      if (!control || !meta) return;

      var host = meta.parent;
      if (host && host.isConnected) {
        host.appendChild(control);
        return;
      }

      var anchor = meta.anchor;
      if (anchor && anchor.isConnected) {
        getItemControlHost(anchor).appendChild(control);
      } else if (card.contains(control)) {
        card.appendChild(control);
      }
    });
  }

  function getColumnFieldControl(col) {
    if (!col) return null;
    return col.querySelector('.ciw-la-rx-grid__col-field select, .ciw-la-rx-grid__col-field input.la-form-input');
  }

  function observeSelectDisabled(cell) {
    var control =
      cell.classList && cell.classList.contains('ciw-la-rx-grid__col')
        ? getColumnFieldControl(cell)
        : cell.querySelector('select, input.la-form-input');
    if (!control || control.dataset.ciwLaContactDisabledObserved === '1') {
      return;
    }

    control.dataset.ciwLaContactDisabledObserved = '1';
    syncColumnDisabledState(cell, control);

    new MutationObserver(function () {
      syncColumnDisabledState(cell, control);
    }).observe(control, { attributes: true, attributeFilter: ['disabled'] });
  }

  function syncColumnDisabledState(cell, control) {
    if (!cell || !control) return;

    var select =
      control.matches && (control.matches('select') || control.matches('input.la-form-input'))
        ? control
        : control.querySelector('select, input.la-form-input');
    var disabled = select
      ? select.disabled
      : control.classList.contains('disabled') || control.getAttribute('aria-disabled') === 'true';

    cell.classList.toggle('ciw-la-rx-grid__col--disabled', !!disabled);
    cell.classList.toggle('ciw-la-rx-grid__field--disabled', !!disabled);
  }

  function isContactGridField(field) {
    if (!field || field.form !== getContactForm()) return false;
    return !!field.closest('.ciw-la-contact-rx-card .ciw-la-rx-grid__col-field, .ciw-la-contact-rx-card .ciw-la-rx-grid__field');
  }

  function getGridCellForField(field) {
    return field && field.closest ? field.closest('.ciw-la-rx-grid__col, .ciw-la-rx-grid__field') : null;
  }

  function getGridColForField(field) {
    return getGridCellForField(field);
  }

  function clearContactNativeFieldErrorStyle(field) {
    if (!field || !field.style) return;
    field.style.borderColor = '';
    field.style.border = '';
    field.style.boxShadow = '';
    field.style.outline = '';
    field.style.background = '';
  }

  function stripContactGridLaFieldChrome(form) {
    form = form || getContactForm();
    if (!form) return;

    form.querySelectorAll('.ciw-la-contact-rx-card .ciw-la-rx-grid__col-field :is(select, input), .ciw-la-contact-rx-card .ciw-la-rx-grid__field :is(select, input)').forEach(function (field) {
      clearContactNativeFieldErrorStyle(field);
    });

    var active = document.activeElement;
    if (active && isContactGridField(active)) {
      active.blur();
    }
  }

  function shouldShowContactGridErrors(form) {
    form = form || getContactForm();
    return !!(form && form.dataset.ciwLaContactRxShowErrors === '1');
  }

  function markContactRxSubmitAttempted(form) {
    form = form || getContactForm();
    if (!form) return;
    form.dataset.ciwLaContactRxShowErrors = '1';
  }

  function resetContactRxSubmitAttempt(form) {
    form = form || getContactForm();
    if (!form) return;
    delete form.dataset.ciwLaContactRxShowErrors;
    clearContactGridValidationErrors(form);
  }

  function clearContactGridValidationErrors(form) {
    form = form || getContactForm();
    if (!form) return;

    form.querySelectorAll('.ciw-la-contact-rx-card .ciw-la-rx-grid__col--error, .ciw-la-contact-rx-card .ciw-la-rx-grid__field--error').forEach(function (cell) {
      cell.classList.remove('ciw-la-rx-grid__col--error', 'ciw-la-rx-grid__field--error');
    });

    form.querySelectorAll('.ciw-la-contact-rx-card .ciw-la-rx-grid__col-field :is(select, input), .ciw-la-contact-rx-card .ciw-la-rx-grid__field :is(select, input)').forEach(clearContactNativeFieldErrorStyle);
  }

  function markContactGridFieldError(field, hasError) {
    if (hasError && !shouldShowContactGridErrors(field && field.form)) return;
    var cell = getGridCellForField(field);
    if (!cell) return;
    cell.classList.toggle('ciw-la-rx-grid__col--error', !!hasError);
    cell.classList.toggle('ciw-la-rx-grid__field--error', !!hasError);
    clearContactNativeFieldErrorStyle(field);
  }

  function syncContactGridValidationErrors(form) {
    form = form || getContactForm();
    if (!form || !form.querySelector('.ciw-la-contact-rx-card')) return;
    if (!shouldShowContactGridErrors(form)) return;

    form.querySelectorAll('.ciw-la-contact-rx-card .ciw-la-rx-grid__col--error, .ciw-la-contact-rx-card .ciw-la-rx-grid__field--error').forEach(function (cell) {
      cell.classList.remove('ciw-la-rx-grid__col--error', 'ciw-la-rx-grid__field--error');
    });

    Array.from(form.elements).forEach(function (field) {
      if (!field || field.type === 'submit' || field.type === 'button') return;
      if (!isContactGridField(field)) return;
      if (field.disabled || !field.willValidate) return;
      if (!field.checkValidity()) {
        markContactGridFieldError(field, true);
      }
    });

    form.querySelectorAll('.ciw-la-contact-rx-card .ciw-la-rx-grid__col-field :is(select, input), .ciw-la-contact-rx-card .ciw-la-rx-grid__field :is(select, input)').forEach(clearContactNativeFieldErrorStyle);
  }

  function runContactRxValidationUi(form) {
    form = form || getContactForm();
    if (!form || !form.querySelector('.ciw-la-contact-rx-card')) return;
    if (!shouldShowContactGridErrors(form)) return;

    window.requestAnimationFrame(function () {
      if (!form.checkValidity()) {
        syncContactGridValidationErrors(form);
        stripContactGridLaFieldChrome(form);
        window.requestAnimationFrame(function () {
          stripContactGridLaFieldChrome(form);
        });
      } else {
        clearContactGridValidationErrors(form);
      }
    });
  }

  function ensureContactValidationUi(form) {
    form = form || getContactForm();
    if (!form || !form.querySelector('.ciw-la-contact-rx-card')) return;

    if (form.dataset.ciwLaContactValidationUi !== '1') {
      form.dataset.ciwLaContactValidationUi = '1';

      document.addEventListener(
        'click',
        function (event) {
          var btn = event.target && event.target.closest ? event.target.closest('.la-prescription-form-btn') : null;
          if (!btn || !btn.closest('#lensadvizor-prescription-modal')) return;
          var activeForm = getContactForm();
          if (!activeForm || !activeForm.querySelector('.ciw-la-contact-rx-card')) return;
          if (!activeForm.contains(btn) && !btn.closest('.la-prescription-modal-footer')) return;
          markContactRxSubmitAttempted(activeForm);
          runContactRxValidationUi(activeForm);
        },
        true
      );

      form.addEventListener(
        'invalid',
        function (event) {
          var field = event.target;
          if (!isContactGridField(field)) return;
          event.preventDefault();
          window.requestAnimationFrame(function () {
            clearContactNativeFieldErrorStyle(field);
            if (field === document.activeElement) {
              field.blur();
            }
          });
        },
        true
      );

      form.addEventListener(
        'change',
        function (event) {
          var field = event.target;
          if (!isContactGridField(field)) return;
          if (!shouldShowContactGridErrors(form)) return;
          if (field.checkValidity()) {
            markContactGridFieldError(field, false);
          }
        },
        true
      );

      form.addEventListener(
        'input',
        function (event) {
          var field = event.target;
          if (!isContactGridField(field)) return;
          if (!shouldShowContactGridErrors(form)) return;
          if (field.checkValidity()) {
            markContactGridFieldError(field, false);
          }
        },
        true
      );
    }
  }

  function buildContactGridRow(items, columns, rowClass, usedItems, restoreMap) {
    var grid = document.createElement('div');
    grid.className = 'ciw-la-rx-grid ciw-la-rx-grid--eye ' + rowClass;
    grid.setAttribute('role', 'group');

    columns.forEach(function (column, index) {
      var item = findItemBySlot(items, column.slot, usedItems);
      if (!item) return;

      usedItems.add(item);

      var col = document.createElement('div');
      col.className = 'ciw-la-rx-grid__col';
      if (index > 0) {
        col.classList.add('ciw-la-rx-grid__col--split');
      }

      var field = document.createElement('div');
      field.className = 'ciw-la-rx-grid__col-field';
      appendItemToCell(field, item, restoreMap);

      col.appendChild(buildColumnHead(column));
      col.appendChild(field);
      grid.appendChild(col);

      observeSelectDisabled(col);
    });

    return grid;
  }

  function buildContactEyeBlock(title, items, rowClass, restoreMap) {
    var block = document.createElement('div');
    block.className = 'ciw-la-rx-eye-block ' + rowClass;

    var titleEl = document.createElement('div');
    titleEl.className = 'ciw-la-rx-eye-block__title';
    titleEl.textContent = title;
    block.appendChild(titleEl);

    var usedItems = new Set();

    var primary = buildContactGridRow(items, ROW_PRIMARY, 'ciw-la-rx-grid--contact-primary', usedItems, restoreMap);
    if (primary.childElementCount) {
      block.appendChild(primary);
    }

    var secondary = buildContactGridRow(items, ROW_SECONDARY, 'ciw-la-rx-grid--contact-secondary', usedItems, restoreMap);
    if (secondary.childElementCount) {
      block.classList.add('ciw-la-contact-eye-block--toric');
      secondary.style.setProperty('margin-top', '20px', 'important');
      block.appendChild(secondary);
    }

    var addItem = findItemBySlot(items, 'add', usedItems);
    if (addItem) {
      usedItems.add(addItem);

      var addGrid = document.createElement('div');
      addGrid.className = 'ciw-la-rx-grid ciw-la-rx-grid--eye ciw-la-rx-grid--eye-add';

      var col = document.createElement('div');
      col.className = 'ciw-la-rx-grid__col';

      var field = document.createElement('div');
      field.className = 'ciw-la-rx-grid__col-field';
      appendItemToCell(field, addItem, restoreMap);

      col.appendChild(buildColumnHead({ name: 'Add', acronym: '(ADD)' }));
      col.appendChild(field);
      addGrid.appendChild(col);
      block.appendChild(addGrid);

      observeSelectDisabled(col);
    }

    return block;
  }

  function buildContactDesktopGrid(rightItems, leftItems, restoreMap) {
    var grid = document.createElement('div');
    grid.className = 'ciw-la-rx-grid ciw-la-rx-grid--core ciw-la-rx-grid--contact-desktop';
    grid.setAttribute('role', 'table');

    var corner = document.createElement('div');
    corner.className = 'ciw-la-rx-grid__corner';
    corner.setAttribute('aria-hidden', 'true');
    grid.appendChild(corner);

    CONTACT_DESKTOP_COLUMNS.forEach(function (column, index) {
      var head = document.createElement('div');
      head.className = 'ciw-la-rx-grid__head';
      if (index > 0) {
        head.classList.add('ciw-la-rx-grid__head--split');
      }
      head.setAttribute('role', 'columnheader');
      head.textContent = column.name;
      grid.appendChild(head);
    });

    function appendDataRow(eyeLabel, items, rowClass, rowModifierClass) {
      var label = document.createElement('div');
      label.className = 'ciw-la-rx-grid__label ' + rowClass;
      label.setAttribute('role', 'rowheader');
      label.textContent = eyeLabel;
      grid.appendChild(label);

      var usedItems = new Set();
      CONTACT_DESKTOP_COLUMNS.forEach(function (column, index) {
        var item = findItemBySlot(items, column.slot, usedItems);
        if (item) {
          usedItems.add(item);
        }

        var field = document.createElement('div');
        field.className = 'ciw-la-rx-grid__field';
        field.setAttribute('role', 'cell');
        if (rowModifierClass) {
          field.classList.add(rowModifierClass);
        }
        if (index > 0) {
          field.classList.add('ciw-la-rx-grid__field--split');
        }
        if (item) {
          appendItemToCell(field, item, restoreMap);
        }
        grid.appendChild(field);
        observeSelectDisabled(field);
      });
    }

    appendDataRow('Right (OD)', rightItems, 'ciw-la-rx-grid__row--od', 'ciw-la-rx-grid__field--od');
    appendDataRow('Left (OS)', leftItems, 'ciw-la-rx-grid__row--os', 'ciw-la-rx-grid__field--os');

    return grid;
  }

  function buildContactDesktopAddGrid(rightAddItem, leftAddItem, restoreMap) {
    var grid = document.createElement('div');
    grid.className = 'ciw-la-rx-grid ciw-la-rx-grid--add ciw-la-rx-grid--contact-desktop-add';
    grid.setAttribute('role', 'table');

    var corner = document.createElement('div');
    corner.className = 'ciw-la-rx-grid__corner';
    corner.setAttribute('aria-hidden', 'true');
    grid.appendChild(corner);

    var addHead = document.createElement('div');
    addHead.className = 'ciw-la-rx-grid__head';
    addHead.setAttribute('role', 'columnheader');
    addHead.textContent = 'ADD';
    grid.appendChild(addHead);

    function appendAddRow(eyeLabel, item, rowClass, rowModifierClass) {
      var label = document.createElement('div');
      label.className = 'ciw-la-rx-grid__label ' + rowClass;
      label.setAttribute('role', 'rowheader');
      label.textContent = eyeLabel;
      grid.appendChild(label);

      var field = document.createElement('div');
      field.className = 'ciw-la-rx-grid__field ciw-la-rx-grid__field--wide';
      field.setAttribute('role', 'cell');
      if (rowModifierClass) {
        field.classList.add(rowModifierClass);
      }
      if (item) {
        appendItemToCell(field, item, restoreMap);
      }
      grid.appendChild(field);
      observeSelectDisabled(field);
    }

    appendAddRow('Right (OD)', rightAddItem, 'ciw-la-rx-grid__row--od', 'ciw-la-rx-grid__field--od');
    appendAddRow('Left (OS)', leftAddItem, 'ciw-la-rx-grid__row--os', 'ciw-la-rx-grid__field--os');

    return grid;
  }

  function buildContactRxStack(rightItems, leftItems, restoreMap) {
    var stack = document.createElement('div');
    stack.className = 'ciw-la-rx-stack--mobile ciw-la-contact-rx-stack';

    if (contactUsesDesktopGrid(rightItems, leftItems)) {
      stack.classList.add('ciw-la-contact-rx-stack--desktop');
      stack.appendChild(buildContactDesktopGrid(rightItems, leftItems, restoreMap));

      var rightUsed = new Set();
      var leftUsed = new Set();
      var rightAddItem = findItemBySlot(rightItems, 'add', rightUsed);
      var leftAddItem = findItemBySlot(leftItems, 'add', leftUsed);
      if (rightAddItem || leftAddItem) {
        stack.appendChild(buildContactDesktopAddGrid(rightAddItem, leftAddItem, restoreMap));
      }
      return stack;
    }

    stack.appendChild(buildContactEyeBlock('Right eye (OD)', rightItems, 'ciw-la-rx-eye-block--od', restoreMap));
    stack.appendChild(buildContactEyeBlock('Left eye (OS)', leftItems, 'ciw-la-rx-eye-block--os', restoreMap));
    return stack;
  }

  function buildContactHeading() {
    var heading = document.createElement('div');
    heading.className = 'ciw-la-manual-rx-heading';

    var title = document.createElement('h3');
    title.className = 'ciw-la-manual-rx-heading__title';
    title.textContent = 'Fill prescription manually';

    heading.appendChild(title);
    return heading;
  }

  function hideScanElements(form) {
    if (!form) return;

    var selectors = [
      '.la-upload-wrapper',
      '[data-la-scan-box]',
      '.la-scan-box-wrapper',
      '.la-barcode-scan-wrapper',
      '.ciw-la-contact-scan'
    ];

    selectors.forEach(function (selector) {
      form.querySelectorAll(selector).forEach(hideElement);
    });
  }

  function getManualRxApi() {
    return window.ciwLaManualRxEnhanceApi || null;
  }

  function isContactPrescriptionConfirmCheckbox(input) {
    if (!input || input.type !== 'checkbox') return false;

    if (input.id === 'la-upload-confirmation' || input.id === 'ciw-la-upload-confirmation-fallback') {
      return true;
    }

    if (input.name === 'la-upload-confirmation') {
      return true;
    }

    var label = input.closest('.la-checkox-wrapper-label, label');
    var text = label ? String(label.textContent || '').toLowerCase() : '';
    return (
      text.indexOf('confirm') >= 0 ||
      (text.indexOf('prescription') >= 0 && text.indexOf('correct') >= 0) ||
      (text.indexOf('valid') >= 0 && text.indexOf('expired') >= 0)
    );
  }

  function findPrescriptionConfirmCheckboxIn(scope) {
    if (!scope) return null;

    var named = scope.querySelector(
      '#la-upload-confirmation, #ciw-la-upload-confirmation-fallback, input[name="la-upload-confirmation"]'
    );
    if (named) return named;

    var api = getManualRxApi();
    var candidates = scope.querySelectorAll('input[type="checkbox"]');

    for (var i = 0; i < candidates.length; i++) {
      var input = candidates[i];
      if (api && typeof api.isPrescriptionConfirmCheckbox === 'function') {
        if (api.isPrescriptionConfirmCheckbox(input)) {
          return input;
        }
        continue;
      }

      if (isContactPrescriptionConfirmCheckbox(input)) {
        return input;
      }
    }

    return null;
  }

  function findPrescriptionConfirmCheckbox(form) {
    form = form || getContactForm();
    if (!form) return null;

    var card = form.querySelector(ENHANCED_MARKER);
    if (card) {
      var inCard = findPrescriptionConfirmCheckboxIn(card);
      if (inCard) return inCard;
    }

    var api = getManualRxApi();
    if (api && typeof api.findPrescriptionConfirmCheckbox === 'function') {
      return api.findPrescriptionConfirmCheckbox(form);
    }

    return findPrescriptionConfirmCheckboxIn(form);
  }

  function resolveContactConfirmRow(node) {
    if (!node) return null;

    if (node.matches('.ciw-la-manual-rx-confirm-row, .la-prescription-fields-wrapper, .la-checkox-wrapper-label, label')) {
      return node;
    }

    return (
      node.closest('.ciw-la-manual-rx-confirm-row, .la-prescription-fields-wrapper') ||
      node.closest('.la-checkox-wrapper-label, label') ||
      node
    );
  }

  function isSameRxLabelText(text) {
    text = String(text || '').toLowerCase();
    if (!text) return false;
    if (text.indexOf('confirm') >= 0 && text.indexOf('prescription') >= 0) return false;
    if (text.indexOf('valid') >= 0 && text.indexOf('expired') >= 0) return false;
    return (
      text.indexOf('same') >= 0 ||
      text.indexOf('both eyes') >= 0 ||
      text.indexOf('both eye') >= 0 ||
      text.indexOf('graduation') >= 0 ||
      text.indexOf('one graduation') >= 0 ||
      text.indexOf('only one') >= 0
    );
  }

  function resolveSameRxRow(node) {
    if (!node) return null;

    if (node.matches('.la-checkox-wrapper-label, label')) {
      return node;
    }

    if (node.matches('input[type="checkbox"]')) {
      var inputLabel = node.closest('.la-checkox-wrapper-label, label');
      if (inputLabel) return inputLabel;
    }

    var nestedLabel = node.querySelector('.la-checkox-wrapper-label, label');
    if (nestedLabel && nestedLabel.querySelector('input[type="checkbox"]')) {
      return nestedLabel;
    }

    if (node.querySelector('input[type="checkbox"]')) {
      return node;
    }

    return node;
  }

  function findSameRxCheckbox(form, fieldsWrapper) {
    form = form || getContactForm();
    if (!form) return null;

    var prescriptionConfirm = findPrescriptionConfirmCheckbox(form);
    var scopes = [form];
    var lensWrapper = document.querySelector('.la-contact-lenswrapper');
    if (lensWrapper) scopes.push(lensWrapper);

    var graduationField =
      form.querySelector('#la-graduation-field, .la-graduation-field, [id*="graduation-field"]') ||
      (lensWrapper &&
        lensWrapper.querySelector('#la-graduation-field, .la-graduation-field, [id*="graduation-field"]'));
    if (graduationField) {
      var graduationRow = resolveSameRxRow(graduationField);
      if (graduationRow && !(prescriptionConfirm && graduationRow.contains(prescriptionConfirm))) {
        return graduationRow;
      }
    }

    var graduationLabel = form.querySelector('label[for="la-graduation-field"]');
    if (graduationLabel && !(prescriptionConfirm && graduationLabel.contains(prescriptionConfirm))) {
      return graduationLabel;
    }

    for (var scopeIndex = 0; scopeIndex < scopes.length; scopeIndex++) {
      var labels = scopes[scopeIndex].querySelectorAll(
        '.la-checkox-wrapper-label, label.la-checkox-wrapper-label, label:has(input[type="checkbox"])'
      );

      for (var i = 0; i < labels.length; i++) {
        var label = labels[i];
        if (label.closest('.la-quantity-selector-wrapper, .ciw-la-manual-rx-confirm-row, .ciw-la-contact-rx-card')) {
          continue;
        }
        if (prescriptionConfirm && label.contains(prescriptionConfirm)) continue;
        if (!label.querySelector('input[type="checkbox"]')) continue;

        if (isSameRxLabelText(label.textContent)) {
          return label;
        }
      }
    }

    var namedInput = form.querySelector(
      'input[type="checkbox"][name*="graduation"], input[type="checkbox"][id*="graduation"], input[type="checkbox"][name*="same_rx"], input[type="checkbox"][name*="same-rx"]'
    );
    if (namedInput) {
      return resolveSameRxRow(namedInput);
    }

    return null;
  }

  function resolveSameRxCheckboxInput(node, form) {
    form = form || getContactForm();
    var checkbox = null;
    var label = null;

    if (!node) {
      return { checkbox: null, label: null };
    }

    if (node.matches && node.matches('input[type="checkbox"]')) {
      checkbox = node;
    } else if (node.matches && node.matches('.la-checkox-wrapper-label, label')) {
      label = node;
    } else if (node.querySelector) {
      checkbox = node.querySelector('input[type="checkbox"]');
      label = node.querySelector('.la-checkox-wrapper-label, label');
    }

    if (label && !checkbox) {
      checkbox = label.querySelector('input[type="checkbox"]');
      if (!checkbox && label.htmlFor) {
        checkbox = document.getElementById(label.htmlFor);
      }
    }

    if (!checkbox && form) {
      checkbox = form.querySelector(
        'input#la-graduation-field[type="checkbox"], input[type="checkbox"][id="la-graduation-field"], input[type="checkbox"][name*="graduation"]'
      );
    }

    if (!label && checkbox) {
      label = checkbox.closest('.la-checkox-wrapper-label, label');
      if (!label && checkbox.id) {
        label = form ? form.querySelector('label[for="' + checkbox.id + '"]') : null;
      }
    }

    return { checkbox: checkbox, label: label };
  }

  function findSameRxWrapper(form, fieldsWrapper) {
    form = form || getContactForm();
    if (!form) return null;

    fieldsWrapper = fieldsWrapper || form.querySelector('.la-fields-wrapper') || form;
    return fieldsWrapper.querySelector(
      ':scope > .ciw-la-contact-same-rx:not(label):not(.la-checkox-wrapper-label):not(input)'
    );
  }

  function buildSameRxWrapper(node) {
    var form = getContactForm();
    var parts = resolveSameRxCheckboxInput(node, form);
    var checkbox = parts.checkbox;
    var label = parts.label;

    if (!checkbox && !label) return null;
    if (checkbox && isContactPrescriptionConfirmCheckbox(checkbox)) return null;

    var wrapper = null;
    if (
      node &&
      node.matches &&
      node.matches('.ciw-la-contact-same-rx') &&
      !node.matches('label, .la-checkox-wrapper-label, input')
    ) {
      wrapper = node;
    } else if (node && node.closest) {
      wrapper = node.closest('.ciw-la-contact-same-rx:not(label):not(.la-checkox-wrapper-label):not(input)');
    }

    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'ciw-la-contact-same-rx';
      var anchor = label || checkbox;
      if (anchor && anchor.parentElement) {
        anchor.parentElement.insertBefore(wrapper, anchor);
      }
    }

    wrapper.classList.add('ciw-la-contact-same-rx');

    if (!label) {
      label = document.createElement('label');
      label.className = 'la-h5 la-form-field-label la-checkox-wrapper-label';
      wrapper.appendChild(label);
    } else {
      label.classList.remove('ciw-la-contact-same-rx');
      if (!wrapper.contains(label)) {
        wrapper.appendChild(label);
      }
    }

    if (checkbox) {
      if (!checkbox.id) {
        checkbox.id = 'la-graduation-field';
      }
      label.htmlFor = checkbox.id;
      if (!label.contains(checkbox)) {
        label.insertBefore(checkbox, label.firstChild);
      }
    }

    return wrapper;
  }

  function getSameRxPlacementTarget(row) {
    if (!row) return null;

    var built = buildSameRxWrapper(row);
    if (built) return built;

    var graduationWrapper = row.closest('#la-graduation-field, .la-graduation-field, [id*="graduation-field"]');
    if (graduationWrapper && !graduationWrapper.matches('label, .la-checkox-wrapper-label, input')) {
      return graduationWrapper;
    }

    return row;
  }

  var sameRxTextObserver = null;
  var sameRxTextObserverRoot = null;

  function disconnectSameRxTextObserver() {
    if (sameRxTextObserver) {
      sameRxTextObserver.disconnect();
      sameRxTextObserver = null;
    }
    sameRxTextObserverRoot = null;
  }

  function sameRxTextNeedsReplace(text) {
    text = String(text || '').replace(/\s+/g, ' ').trim();
    if (!text || text === 'Same Rx for both eyes') return false;
    return isSameRxLabelText(text);
  }

  function watchSameRxLabelText(moveTarget) {
    if (!moveTarget || typeof MutationObserver === 'undefined') return;
    if (sameRxTextObserverRoot === moveTarget) return;

    disconnectSameRxTextObserver();
    sameRxTextObserverRoot = moveTarget;

    sameRxTextObserver = new MutationObserver(function () {
      if (observerPaused || enhanceInFlight) return;

      var label = moveTarget.matches('.la-checkox-wrapper-label, label')
        ? moveTarget
        : moveTarget.querySelector('.la-checkox-wrapper-label, label');
      var textEl = moveTarget.querySelector('.la-checkox-label');
      var visible = textEl
        ? textEl.textContent
        : label
          ? label.textContent.replace(/\s+/g, ' ').trim()
          : moveTarget.textContent.replace(/\s+/g, ' ').trim();

      if (!sameRxTextNeedsReplace(visible)) return;
      markSameRxCheckbox(moveTarget, true);
    });

    sameRxTextObserver.observe(moveTarget, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function getSameRxInput(form) {
    form = form || getContactForm();
    if (!form) return null;

    var wrapper = findSameRxWrapper(form);
    if (wrapper) {
      var inTarget = wrapper.querySelector('input[type="checkbox"]');
      if (inTarget && !isContactPrescriptionConfirmCheckbox(inTarget)) {
        return inTarget;
      }
    }

    var row = findSameRxCheckbox(form);
    if (!row) return null;

    var parts = resolveSameRxCheckboxInput(row, form);
    if (parts.checkbox && !isContactPrescriptionConfirmCheckbox(parts.checkbox)) {
      return parts.checkbox;
    }

    return null;
  }

  function isContactSameRxActive(form) {
    var input = getSameRxInput(form);
    return !!(input && input.checked);
  }

  var sameRxToggleBound = new WeakSet();

  function bindSameRxToggle(checkbox) {
    if (!checkbox || sameRxToggleBound.has(checkbox)) return;
    sameRxToggleBound.add(checkbox);
    checkbox.addEventListener('change', function () {
      window.setTimeout(function () {
        syncContactEyeBlocks(getContactForm());
      }, 0);
      window.setTimeout(function () {
        syncContactEyeBlocks(getContactForm());
      }, 120);
    });
  }

  function markSameRxCheckbox(node, fromObserver) {
    if (!node) return;
    var moveTarget = buildSameRxWrapper(node) || getSameRxPlacementTarget(node) || node;
    if (moveTarget.matches && moveTarget.matches('label, .la-checkox-wrapper-label, input')) {
      moveTarget = buildSameRxWrapper(moveTarget) || moveTarget;
    }
    if (moveTarget.matches && moveTarget.matches('label, .la-checkox-wrapper-label, input')) {
      return;
    }

    moveTarget.classList.add('ciw-la-contact-same-rx');

    var parts = resolveSameRxCheckboxInput(moveTarget, getContactForm());
    var checkbox = parts.checkbox;
    var label = parts.label;
    if (checkbox && isContactPrescriptionConfirmCheckbox(checkbox)) return;

    if (!label) {
      label = document.createElement('label');
      label.className = 'la-h5 la-form-field-label la-checkox-wrapper-label';
      moveTarget.appendChild(label);
    } else {
      label.classList.remove('ciw-la-contact-same-rx');
      if (!moveTarget.contains(label)) {
        moveTarget.appendChild(label);
      }
    }

    if (checkbox && !label.contains(checkbox)) {
      if (!checkbox.id) {
        checkbox.id = 'la-graduation-field';
      }
      label.htmlFor = checkbox.id;
      label.insertBefore(checkbox, label.firstChild);
    } else if (!checkbox) {
      checkbox = label.querySelector('input[type="checkbox"]');
    }

    var newText = 'Same Rx for both eyes';
    var textSpan = label.querySelector('.la-checkox-label');
    if (!textSpan) {
      textSpan = document.createElement('span');
      textSpan.className = 'la-checkox-label';
      label.appendChild(textSpan);
    }
    textSpan.textContent = newText;

    Array.from(label.childNodes).forEach(function (child) {
      if (child === checkbox || child === textSpan) return;
      if (child.nodeType === 1 && child.tagName === 'INPUT') return;
      if (child.nodeType === Node.TEXT_NODE && String(child.textContent || '').trim()) {
        child.remove();
        return;
      }
      if (child.nodeType === 1) {
        child.remove();
      }
    });

    bindSameRxToggle(checkbox);

    if (!fromObserver) {
      watchSameRxLabelText(moveTarget);
    }
  }

  function ensureCardFollowsSameRx(fieldsWrapper, card) {
    if (!fieldsWrapper || !card) return;

    var sameRx = findSameRxWrapper(getContactForm(), fieldsWrapper);
    if (!sameRx || sameRx.nextElementSibling === card) return;

    fieldsWrapper.insertBefore(card, sameRx.nextElementSibling);
  }

  function isContactSameRxPlaced(form) {
    form = form || getContactForm();
    if (!form) return false;

    var fieldsWrapper = form.querySelector('.la-fields-wrapper') || form;
    var placed = findSameRxWrapper(form, fieldsWrapper);
    if (!placed) {
      var brokenLabel = fieldsWrapper.querySelector(':scope > label.ciw-la-contact-same-rx');
      if (brokenLabel) {
        markSameRxCheckbox(brokenLabel);
        placed = findSameRxWrapper(form, fieldsWrapper);
      }
    }
    if (!placed) return false;

    var checkbox = placed.querySelector('input[type="checkbox"]');
    return !!(checkbox && !isContactPrescriptionConfirmCheckbox(checkbox));
  }

  function contactGraduationSourceExists(form) {
    form = form || getContactForm();
    if (!form || isContactSameRxPlaced(form)) return false;

    var lensWrapper = document.querySelector('.la-contact-lenswrapper');
    var graduationField =
      form.querySelector('#la-graduation-field, .la-graduation-field, [id*="graduation-field"]') ||
      (lensWrapper &&
        lensWrapper.querySelector('#la-graduation-field, .la-graduation-field, [id*="graduation-field"]'));
    if (graduationField) return true;

    if (
      form.querySelector(
        'input[type="checkbox"][name*="graduation"], input[type="checkbox"][id*="graduation"], input[type="checkbox"][name*="same_rx"], input[type="checkbox"][name*="same-rx"]'
      )
    ) {
      return true;
    }

    var prescriptionConfirm = findPrescriptionConfirmCheckbox(form);
    var labels = form.querySelectorAll('.la-checkox-wrapper-label, label.la-checkox-wrapper-label, label');
    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      if (label.closest('.la-quantity-selector-wrapper, .ciw-la-manual-rx-confirm-row, .ciw-la-contact-rx-card')) {
        continue;
      }
      if (prescriptionConfirm && label.contains(prescriptionConfirm)) continue;
      if (!label.querySelector('input[type="checkbox"]')) continue;
      if (isSameRxLabelText(label.textContent)) return true;
    }

    return false;
  }

  function ensureContactSameRxPlaced(form, card, fieldsWrapper) {
    if (!form) return false;

    fieldsWrapper = fieldsWrapper || form.querySelector('.la-fields-wrapper') || form;

    if (isContactSameRxPlaced(form)) {
      var placed = findSameRxWrapper(form, fieldsWrapper);
      if (placed) {
        markSameRxCheckbox(placed);
        revealElement(placed);
      }
      if (card) {
        ensureCardFollowsSameRx(fieldsWrapper, card);
      }
      syncContactEyeBlocks(form);
      return true;
    }

    var sameRxCheckbox = resolveSameRxRow(findSameRxCheckbox(form, fieldsWrapper));
    if (!sameRxCheckbox) return false;

    var heading = fieldsWrapper.querySelector('.ciw-la-manual-rx-heading');
    hideDuplicateConfirmCheckboxes(form, card, sameRxCheckbox);
    placeContactSameRxBelowHeading(fieldsWrapper, heading, sameRxCheckbox, card);
    return isContactSameRxPlaced(form);
  }

  function scheduleSameRxPlacementRetries(form) {
    if (!form) return;

    [50, 150, 350, 700, 1200, 2000].forEach(function (delay) {
      window.setTimeout(function () {
        if (!document.body.classList.contains('la-modal-open')) return;

        var currentForm = getContactForm();
        if (!currentForm || currentForm !== form) return;

        var card = currentForm.querySelector(ENHANCED_MARKER);
        if (!card) return;
        if (isContactSameRxPlaced(currentForm)) return;

        var fieldsWrapper = currentForm.querySelector('.la-fields-wrapper') || currentForm;
        if (!contactGraduationSourceExists(currentForm) && !findSameRxCheckbox(currentForm)) {
          return;
        }

        ensureContactSameRxPlaced(currentForm, card, fieldsWrapper);
        hideNativeContactRxContainers(currentForm, card);
        syncContactEyeBlocks(currentForm);
        syncContactReadyState(currentForm, card);
      }, delay);
    });
  }

  function placeContactSameRxBelowHeading(fieldsWrapper, heading, sameRxCheckbox, card) {
    if (!fieldsWrapper || !sameRxCheckbox) {
      return;
    }

    var moveTarget = getSameRxPlacementTarget(sameRxCheckbox);
    markSameRxCheckbox(moveTarget);
    revealElement(moveTarget);

    var anchor = heading ? heading.nextElementSibling : fieldsWrapper.firstChild;
    if (card && anchor === card) {
      anchor = card;
    }

    if (moveTarget.parentElement !== fieldsWrapper) {
      fieldsWrapper.insertBefore(moveTarget, anchor);
    } else if (heading && heading.nextElementSibling !== moveTarget) {
      fieldsWrapper.insertBefore(moveTarget, heading.nextElementSibling);
    }

    bindSameRxToggle(getSameRxInput(fieldsWrapper.closest(FORM_SELECTOR) || getContactForm()));

    if (card) {
      ensureCardFollowsSameRx(fieldsWrapper, card);
    }
  }

  function hideDuplicateConfirmCheckboxes(form, card, activeCheckbox) {
    if (!form || !activeCheckbox) return;

    var prescriptionConfirm = findPrescriptionConfirmCheckbox(form);

    form.querySelectorAll('.la-checkox-wrapper-label').forEach(function (el) {
      if (el === activeCheckbox) return;
      if (prescriptionConfirm && el.contains(prescriptionConfirm)) return;
      if (card && card.contains(el)) return;
      hideElement(el);
    });
  }

  function isInsideEnhancedCard(node, card) {
    if (!node) return false;
    if (card && card.contains(node)) return true;
    return !!node.closest('.ciw-la-contact-rx-card');
  }

  function isEnhancedContactRxNode(node) {
    if (!node) return false;
    return !!node.closest(
      '.ciw-la-manual-rx-section--rx, .ciw-la-rx-stack--mobile, .ciw-la-rx-eye-block, .ciw-la-manual-rx-confirm-row'
    );
  }

  function hideNativeContactElement(el) {
    if (!el || isEnhancedContactRxNode(el)) return;
    el.classList.add('ciw-la-contact-native-stale', 'ciw-la-manual-rx-hidden');
  }

  function purgeStaleNativeFromCard(card) {
    if (!card) return;

    card.querySelectorAll(
      ':scope > .la-left-rx-container, :scope > .la-right-rx-container, :scope > .la-prescription-fields-wrapper'
    ).forEach(function (el) {
      if (el.classList.contains('ciw-la-manual-rx-section--rx') || el.classList.contains('ciw-la-manual-rx-confirm-row')) {
        return;
      }
      hideNativeContactElement(el);
    });

    var confirmRow = card.querySelector(':scope > .ciw-la-manual-rx-confirm-row');
    if (!confirmRow) return;

    var sibling = confirmRow.nextElementSibling;
    while (sibling) {
      var next = sibling.nextElementSibling;
      if (
        sibling.matches('.la-left-rx-container, .la-right-rx-container, .la-prescription-fields-wrapper') ||
        sibling.querySelector('.la-form-item[key]')
      ) {
        hideNativeContactElement(sibling);
      }
      sibling = next;
    }
  }

  function hideNativeContactRxContainers(form, card) {
    if (!form || !card) return;

    var fieldsWrapper = form.querySelector('.la-fields-wrapper') || form;
    Array.from(fieldsWrapper.children).forEach(function (child) {
      if (child === card || child.classList.contains('ciw-la-contact-rx-card')) return;
      if (child.classList.contains('ciw-la-manual-rx-heading')) return;
      if (child.classList.contains('ciw-la-contact-same-rx') || child.id === 'la-graduation-field') return;
      hideElement(child);
    });

    form.querySelectorAll('.la-prescription-fields-wrapper').forEach(function (wrapper) {
      if (isEnhancedContactRxNode(wrapper)) return;
      if (wrapper.querySelector('.la-form-item[key]')) {
        hideNativeContactElement(wrapper);
      }
    });

    form.querySelectorAll('.la-right-rx-container, .la-left-rx-container').forEach(function (el) {
      if (isEnhancedContactRxNode(el)) return;
      hideNativeContactElement(el);
    });

    purgeStaleNativeFromCard(card);

    var quantity = findQuantityWrapper(form);
    if (quantity && !isInsideEnhancedCard(quantity, card)) {
      hideContactManualQuantity(form, quantity);
    }

    form.querySelectorAll('.la-h6, h6, .la-eye-title').forEach(function (heading) {
      if (isEnhancedContactRxNode(heading)) return;
      if (heading.closest('.la-quantity-selector-wrapper, .ciw-la-contact-quantity, .ciw-la-contact-rx-card')) return;
      var text = heading.textContent.toLowerCase();
      if (
        text.indexOf('od') >= 0 ||
        text.indexOf('os') >= 0 ||
        text.indexOf('right') >= 0 ||
        text.indexOf('left') >= 0
      ) {
        hideNativeContactElement(heading);
      }
    });
  }

  function findQuantityWrapper(form) {
    form = form || getContactForm();
    if (!form) {
      return document.querySelector('.la-quantity-selector-wrapper');
    }

    return form.querySelector('.la-quantity-selector-wrapper') || document.querySelector('.la-quantity-selector-wrapper');
  }

  function isQuantityTitleText(text) {
    text = String(text || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
    if (!text) return false;
    if (text.indexOf('confirm') >= 0 || text.indexOf('prescription') >= 0) return false;
    if (text.indexOf('same') >= 0 || text.indexOf('graduation') >= 0 || text.indexOf('both eye') >= 0) {
      return false;
    }
    return text.indexOf('quantity') >= 0 || text.indexOf('select qty') >= 0;
  }

  function isQuantityTitleNode(node) {
    if (!node || node.nodeType !== 1) return false;
    if (
      node.matches(
        '.la-quantity-selector, .la-quantity-selector-wrapper, .ciw-la-manual-rx-confirm-row, .la-checkox-wrapper-label, label, .ciw-la-manual-rx-heading, .ciw-la-contact-same-rx'
      )
    ) {
      return false;
    }
    if (node.querySelector('.la-quantity-selector')) return false;
    if (!node.matches('.la-h6, h6, .la-wrapper-heading, p')) return false;
    return isQuantityTitleText(node.textContent);
  }

  function findQuantityTitle(form, quantity) {
    form = form || getContactForm();
    if (!quantity) return null;

    var inside = quantity.querySelectorAll('.la-h6, h6, .la-wrapper-heading, p');
    for (var i = 0; i < inside.length; i++) {
      if (isQuantityTitleNode(inside[i])) return inside[i];
    }

    var sibling = quantity.previousElementSibling;
    if (sibling && isQuantityTitleNode(sibling)) return sibling;

    var fieldsWrapper = form && form.querySelector('.la-fields-wrapper');
    if (fieldsWrapper) {
      var direct = fieldsWrapper.querySelectorAll(':scope > .la-h6, :scope > h6, :scope > .la-wrapper-heading, :scope > p');
      for (var j = 0; j < direct.length; j++) {
        if (isQuantityTitleNode(direct[j])) return direct[j];
      }
    }

    return null;
  }

  function ensureQuantityTitlePlacement(form, quantity) {
    if (!quantity) return;

    var title = findQuantityTitle(form, quantity);
    if (!title) return;

    title.classList.add('ciw-la-contact-quantity-title');
    revealElement(title);

    var firstSelector = quantity.querySelector('.la-quantity-selector');
    if (firstSelector) {
      quantity.insertBefore(title, firstSelector);
      return;
    }

    quantity.insertBefore(title, quantity.firstChild);
  }

  function extractConfirmFromQuantityWrapper(form, quantity) {
    if (!quantity) return null;

    var checkbox = findPrescriptionConfirmCheckboxIn(quantity);
    if (!checkbox) return null;

    var confirmRow = resolveContactConfirmRow(checkbox);
    if (!confirmRow || !quantity.contains(confirmRow)) return null;

    confirmRow.classList.add('ciw-la-manual-rx-confirm-row');
    revealElement(confirmRow);
    confirmRow.remove();
    return confirmRow;
  }

  function stripConfirmNodesFromQuantity(quantity, keepRow) {
    if (!quantity) return;

    quantity.querySelectorAll('.ciw-la-manual-rx-confirm-row, .la-prescription-fields-wrapper, .la-checkox-wrapper-label, label').forEach(
      function (node) {
        if (keepRow && (node === keepRow || keepRow.contains(node) || node.contains(keepRow))) {
          return;
        }

        var input = node.querySelector ? node.querySelector('input[type="checkbox"]') : null;
        if (input && isContactPrescriptionConfirmCheckbox(input)) {
          node.remove();
        }
      }
    );
  }

  function buildContactFallbackPrescriptionConfirm(form) {
    form = form || getContactForm();
    if (!form) return null;

    var confirmRow = document.createElement('div');
    confirmRow.className = 'ciw-la-manual-rx-confirm-row la-prescription-fields-wrapper';
    confirmRow.dataset.ciwLaFallbackConfirm = '1';

    var label = document.createElement('label');
    label.className = 'la-form-field-label la-checkox-wrapper-label';

    var input = document.createElement('input');
    input.type = 'checkbox';
    input.name = 'la-upload-confirmation';
    input.required = true;

    if (!form.querySelector('#la-upload-confirmation')) {
      input.id = 'la-upload-confirmation';
      label.setAttribute('for', 'la-upload-confirmation');
    } else {
      input.id = 'ciw-la-upload-confirmation-fallback';
      label.setAttribute('for', 'ciw-la-upload-confirmation-fallback');
    }

    label.appendChild(input);

    var textSpan = document.createElement('span');
    textSpan.className = 'ciw-la-manual-rx-confirm-text';
    textSpan.textContent =
      'By clicking this box, I confirm that the prescription values entered above are taken from a valid (not expired) prescription issued to me, signed by a licensed optometrist or ophthalmologist.';
    label.appendChild(textSpan);

    confirmRow.appendChild(label);
    return confirmRow;
  }

  function normalizeContactPrescriptionConfirmRow(confirmRow) {
    if (!confirmRow) return;

    var label = confirmRow.matches('.la-checkox-wrapper-label, label')
      ? confirmRow
      : confirmRow.querySelector('.la-checkox-wrapper-label, label');

    if (!label) return;

    confirmRow.querySelectorAll(':scope > .ciw-la-manual-rx-confirm-text, :scope > .la-checkox-label').forEach(function (node) {
      if (!label.contains(node)) {
        label.appendChild(node);
      }
    });

    var nativeLabel = label.querySelector('.la-checkox-label');
    var customText = label.querySelector('.ciw-la-manual-rx-confirm-text');

    if (nativeLabel && customText) {
      customText.remove();
    }

    if (nativeLabel) {
      label.querySelectorAll('.ciw-la-manual-rx-confirm-text').forEach(function (node) {
        node.remove();
      });
      Array.from(label.childNodes).forEach(function (node) {
        if (node === nativeLabel || (node.nodeType === 1 && node.tagName === 'INPUT')) return;
        if (node.nodeType === Node.TEXT_NODE && String(node.textContent || '').trim()) {
          node.remove();
        }
      });
    } else if (customText) {
      Array.from(label.childNodes).forEach(function (node) {
        if (node === customText || (node.nodeType === 1 && node.tagName === 'INPUT')) return;
        if (node.nodeType === Node.TEXT_NODE && String(node.textContent || '').trim()) {
          node.remove();
        }
      });
    }

    var topLabels = Array.from(confirmRow.querySelectorAll(':scope > .la-checkox-wrapper-label, :scope > label')).filter(
      function (node) {
        return node.querySelector('input[type="checkbox"]');
      }
    );
    if (topLabels.length > 1) {
      topLabels.slice(1).forEach(function (node) {
        node.remove();
      });
    }

    confirmRow.classList.remove('la-flex', 'la-form-flex', 'la-column-gap-1-5', 'la-row');
  }

  function ensureContactPrescriptionConfirm(form, card) {
    if (!form || !card) return false;

    var api = getManualRxApi();
    if (api && typeof api.extractConfirmFromUploadWrapper === 'function') {
      api.extractConfirmFromUploadWrapper(form, card);
    }

    var confirmRow = findContactConfirmRow(form, card);

    if (!confirmRow) {
      var formCheckbox = findPrescriptionConfirmCheckbox(form);
      if (formCheckbox) {
        confirmRow = resolveContactConfirmRow(formCheckbox);
        if (confirmRow && !card.contains(confirmRow)) {
          card.appendChild(confirmRow);
        }
      }
    }

    if (!confirmRow) {
      confirmRow = card.querySelector('.ciw-la-manual-rx-confirm-row[data-ciw-la-fallback-confirm="1"]');
      if (!confirmRow) {
        confirmRow = buildContactFallbackPrescriptionConfirm(form);
        if (!confirmRow) return false;
        card.appendChild(confirmRow);
      }
    }

    revealElement(confirmRow);
    confirmRow.classList.add('ciw-la-manual-rx-confirm-row');
    confirmRow.style.removeProperty('display');
    confirmRow.style.removeProperty('visibility');
    confirmRow.style.removeProperty('opacity');
    normalizeContactPrescriptionConfirmRow(confirmRow);
    return true;
  }

  function findContactConfirmRow(form, card) {
    if (!card) return null;

    var confirmRow = card.querySelector(':scope > .ciw-la-manual-rx-confirm-row');
    if (confirmRow) return confirmRow;

    confirmRow = card.querySelector('.ciw-la-manual-rx-confirm-row');
    if (confirmRow) return confirmRow;

    var cardCheckbox = findPrescriptionConfirmCheckboxIn(card);
    if (cardCheckbox) {
      return resolveContactConfirmRow(cardCheckbox);
    }

    var formCheckbox = findPrescriptionConfirmCheckbox(form);
    if (formCheckbox) {
      return resolveContactConfirmRow(formCheckbox);
    }

    return null;
  }

  function isContactCardTailOrdered(card, confirmRow) {
    if (!card || !confirmRow) return false;
    if (!card.contains(confirmRow)) return false;

    var rxSection = card.querySelector('.ciw-la-manual-rx-section--rx');
    if (!rxSection) return false;
    return !!(rxSection.compareDocumentPosition(confirmRow) & Node.DOCUMENT_POSITION_FOLLOWING);
  }

  function orderContactCardTail(card, confirmRow) {
    if (!card || !confirmRow) return;
    card.appendChild(confirmRow);
  }

  function extractConfirmFromUploadWrapper(form) {
    var uploadWrapper = form && form.querySelector('.la-upload-wrapper');
    if (!uploadWrapper) return null;

    var checkbox = findPrescriptionConfirmCheckboxIn(uploadWrapper);
    if (!checkbox) return null;

    var confirmRow = resolveContactConfirmRow(checkbox);
    if (!confirmRow || !uploadWrapper.contains(confirmRow)) return null;

    confirmRow.classList.add('ciw-la-manual-rx-confirm-row');
    revealElement(confirmRow);
    confirmRow.remove();
    return confirmRow;
  }

  function hideUploadWrapperConfirmDuplicates(form, activeConfirmRow) {
    var uploadWrapper = form && form.querySelector('.la-upload-wrapper');
    if (!uploadWrapper || !activeConfirmRow) return;

    uploadWrapper.querySelectorAll('.ciw-la-manual-rx-confirm-row, .la-prescription-fields-wrapper, .la-checkox-wrapper-label, label').forEach(
      function (node) {
        if (node === activeConfirmRow || activeConfirmRow.contains(node) || node.contains(activeConfirmRow)) {
          return;
        }

        var input = node.querySelector ? node.querySelector('input[type="checkbox"]') : null;
        if (input && isContactPrescriptionConfirmCheckbox(input)) {
          hideElement(node);
        }
      }
    );
  }

  function placeContactUploadFormTail(form) {
    if (!form) return;

    var fieldsWrapper = form.querySelector('.la-fields-wrapper') || form;
    var uploadWrapper = form.querySelector('.la-upload-wrapper');
    var quantity = findQuantityWrapper(form);
    var confirmRow = extractConfirmFromQuantityWrapper(form, quantity);

    if (!confirmRow) {
      confirmRow = extractConfirmFromUploadWrapper(form);
    }

    if (quantity) {
      stripConfirmNodesFromQuantity(quantity, confirmRow);
      hideContactManualQuantity(form, quantity);
    }

    if (!confirmRow) {
      var checkbox = findPrescriptionConfirmCheckbox(form);
      if (checkbox) {
        confirmRow = resolveContactConfirmRow(checkbox);
        if (confirmRow && confirmRow.parentElement) {
          confirmRow.classList.add('ciw-la-manual-rx-confirm-row');
          revealElement(confirmRow);
          confirmRow.remove();
        }
      }
    }

    if (!confirmRow) {
      confirmRow = buildContactFallbackPrescriptionConfirm(form);
    }

    if (!confirmRow) return;

    revealElement(confirmRow);
    confirmRow.classList.add('ciw-la-manual-rx-confirm-row', 'ciw-la-contact-upload-confirm-row');
    normalizeContactPrescriptionConfirmRow(confirmRow);

    if (uploadWrapper) {
      if (uploadWrapper.nextElementSibling !== confirmRow) {
        uploadWrapper.insertAdjacentElement('afterend', confirmRow);
      }
    } else if (!fieldsWrapper.contains(confirmRow)) {
      fieldsWrapper.appendChild(confirmRow);
    }

    hideDuplicateContactConfirmRows(form, null, confirmRow);
    hideUploadWrapperConfirmDuplicates(form, confirmRow);
  }

  function scheduleUploadTailRetries(form) {
    if (!form) return;
    [0, 50, 150, 400, 800].forEach(function (delay) {
      window.setTimeout(function () {
        if (isContactUploadStep(form)) {
          placeContactUploadFormTail(form);
        }
      }, delay);
    });
  }

  function hideContactManualQuantity(form, quantity) {
    if (!quantity) return;

    quantity.classList.add('ciw-la-contact-quantity--manual-hidden');
    hideElement(quantity);

    var title = findQuantityTitle(form, quantity);
    if (title && !quantity.contains(title)) {
      title.classList.add('ciw-la-contact-quantity-title--manual-hidden');
      hideElement(title);
    }
  }

  function hideDuplicateContactConfirmRows(form, card, activeConfirmRow) {
    if (!form || !activeConfirmRow) return;

    var activeCheckbox = activeConfirmRow.querySelector
      ? activeConfirmRow.querySelector('input[type="checkbox"]')
      : null;
    if (!activeCheckbox && activeConfirmRow.matches && activeConfirmRow.matches('input[type="checkbox"]')) {
      activeCheckbox = activeConfirmRow;
    }

    form.querySelectorAll('.ciw-la-manual-rx-confirm-row, .la-prescription-fields-wrapper').forEach(function (row) {
      if (row === activeConfirmRow || activeConfirmRow.contains(row) || row.contains(activeConfirmRow)) {
        return;
      }

      if (!row.querySelector('input[type="checkbox"]')) {
        return;
      }

      if (card && card.contains(row)) {
        row.remove();
        return;
      }

      hideElement(row);
    });

    form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      if (!isContactPrescriptionConfirmCheckbox(input)) return;
      if (activeCheckbox && input === activeCheckbox) return;
      if (activeConfirmRow.contains(input)) return;

      var row = resolveContactConfirmRow(input);
      if (!row || row === activeConfirmRow) return;

      if (isConfirmNodeInsideQuantity(row)) {
        row.remove();
        return;
      }

      if (card && card.contains(row)) {
        row.remove();
      } else {
        hideElement(row);
      }
    });
  }

  function placeContactFormTail(form, card, fieldsWrapper) {
    fieldsWrapper = fieldsWrapper || form.querySelector('.la-fields-wrapper') || form;
    ensureContactSameRxPlaced(form, card, fieldsWrapper);

    var quantity = findQuantityWrapper(form);
    var confirmRow = extractConfirmFromQuantityWrapper(form, quantity);

    if (quantity) {
      stripConfirmNodesFromQuantity(quantity, confirmRow);
      hideContactManualQuantity(form, quantity);
    }

    ensureContactPrescriptionConfirm(form, card);

    if (!confirmRow) {
      confirmRow = findContactConfirmRow(form, card);
    }

    if (quantity && confirmRow && quantity.contains(confirmRow)) {
      confirmRow.remove();
    }

    orderContactCardTail(card, confirmRow);
    hideDuplicateContactConfirmRows(form, card, confirmRow);
    if (confirmRow) {
      normalizeContactPrescriptionConfirmRow(confirmRow);
    }
  }

  function syncContactEyeBlocks(form) {
    form = form || getContactForm();
    if (!form) return;

    var card = form.querySelector(ENHANCED_MARKER);
    if (!card) return;

    var sameRx = isContactSameRxActive(form);
    var stack = card.querySelector('.ciw-la-rx-stack--mobile');
    var odBlock = card.querySelector('.ciw-la-rx-eye-block--od');
    var osBlock = card.querySelector('.ciw-la-rx-eye-block--os');
    var desktopGrid = card.querySelector('.ciw-la-rx-grid--contact-desktop');

    if (stack) {
      stack.classList.toggle('ciw-la-contact-rx-stack--same-rx', sameRx);
    }

    if (desktopGrid) {
      desktopGrid.classList.toggle('ciw-la-rx-grid--contact-desktop--same-rx', sameRx);
    }

    if (sameRx) {
      if (odBlock) {
        odBlock.classList.remove('ciw-la-rx-eye-block--inactive');
        odBlock.classList.add('ciw-la-rx-eye-block--same-rx-active');
      }
      if (osBlock) {
        osBlock.classList.add('ciw-la-rx-eye-block--inactive');
      }
      return;
    }

    if (odBlock) {
      odBlock.classList.remove('ciw-la-rx-eye-block--inactive', 'ciw-la-rx-eye-block--same-rx-active');
    }
    if (osBlock) {
      osBlock.classList.remove('ciw-la-rx-eye-block--inactive');
    }
  }

  function styleQuantitySection(form) {
    var quantity = findQuantityWrapper(form);
    if (!quantity) return;

    quantity.classList.add('ciw-la-contact-quantity');
    ensureQuantityTitlePlacement(form, quantity);
  }

  function setContactEnhancePending(form, pending) {
    if (!form) return;
    form.classList.toggle('ciw-la-contact-rx-form--pending', !!pending);
  }

  function setContactNativeSuppressed(form, suppressed) {
    if (!form) return;
    form.classList.toggle('ciw-la-contact-native-suppressed', !!suppressed);
  }

  function setContactReady(form, ready) {
    if (!form) return;
    form.classList.toggle('ciw-la-contact-rx-form--ready', !!ready);
    if (ready) {
      setContactEnhancePending(form, false);
      revealContactManualRxContentBodyAfterEnhance(form);
    }
  }

  function beginContactManualEntry(form) {
    if (!form) return;
    setContactNativeSuppressed(form, true);
    setContactEnhancePending(form, true);
    setContactReady(form, false);
  }

  function syncContactReadyState(form, card) {
    if (!form) return;
    var complete = isContactEnhancementComplete(form, card);
    setContactReady(form, complete);
    if (!complete) {
      setContactEnhancePending(form, true);
    }
  }

  function ensureContactFooter() {
    if (!document.body.classList.contains('la-modal-open')) return;
    if (!isContactManualEntryStep()) return;
    document.dispatchEvent(new CustomEvent('ciw-la-contact-rx:footer-sync'));
  }

  var footerWatch = null;

  function startContactFooterWatch() {
    ensureContactFooter();
    if (footerWatch) return;
    footerWatch = window.setInterval(ensureContactFooter, 200);
  }

  function stopContactFooterWatch() {
    if (!footerWatch) return;
    window.clearInterval(footerWatch);
    footerWatch = null;
  }

  function countEyeControls(scope) {
    if (!scope) return 0;
    return scope.querySelectorAll(
      '.ciw-la-rx-grid__col-field .la-form-select, .ciw-la-rx-grid__col-field select, .ciw-la-rx-grid__col-field input.la-form-input, .ciw-la-rx-grid__field .la-form-select, .ciw-la-rx-grid__field select, .ciw-la-rx-grid__field input.la-form-input'
    ).length;
  }

  function isContactGridComplete(card) {
    if (!card) return false;
    var form = card.closest(FORM_SELECTOR);
    var desktopGrid = card.querySelector('.ciw-la-rx-grid--contact-desktop');
    if (desktopGrid) {
      var desktopCount = countEyeControls(desktopGrid);
      if (isContactSameRxActive(form)) {
        return desktopCount >= 5;
      }
      return desktopCount >= 10;
    }

    var odCount = countEyeControls(card.querySelector('.ciw-la-rx-eye-block--od'));
    if (isContactSameRxActive(form)) {
      return odCount >= 3;
    }
    return odCount >= 3 && countEyeControls(card.querySelector('.ciw-la-rx-eye-block--os')) >= 3;
  }

  function isPrescriptionConfirmReady(form, card) {
    var api = getManualRxApi();
    if (api && typeof api.isConfirmInCard === 'function') {
      return api.isConfirmInCard(form, card);
    }

    return !!card.querySelector('.ciw-la-manual-rx-confirm-row, #la-upload-confirmation, input[name="la-upload-confirmation"]');
  }

  function isSameRxReady(form, card) {
    if (!form) return false;
    if (isContactSameRxPlaced(form)) return true;
    if (contactGraduationSourceExists(form)) return false;
    return true;
  }

  function isContactEnhancementComplete(form, card) {
    if (!form || !card) return false;
    if (!isContactGridComplete(card)) return false;
    if (!isSameRxReady(form, card)) return false;
    if (!isPrescriptionConfirmReady(form, card)) return false;

    var confirmRow = findContactConfirmRow(form, card);
    return isContactCardTailOrdered(card, confirmRow);
  }

  function revealNativeContactFields(form) {
    if (!form) return;

    form.querySelectorAll('.ciw-la-manual-rx-hidden').forEach(function (node) {
      if (node.closest('.ciw-la-contact-rx-card')) return;
      revealElement(node);
    });

    var fieldsWrapper = form.querySelector('.la-fields-wrapper');
    if (fieldsWrapper) {
      Array.from(fieldsWrapper.children).forEach(function (child) {
        if (child.classList.contains('ciw-la-contact-rx-card')) return;
        revealElement(child);
      });
    }
  }

  function isEnhancementStable(form) {
    if (!form || form.dataset.ciwLaContactEnhanced !== '1') return false;
    var card = form.querySelector(ENHANCED_MARKER);
    if (!card) return false;
    var fieldsWrapper = form.querySelector('.la-fields-wrapper') || form;
    if (!fieldsWrapper.contains(card)) return false;
    return isContactEnhancementComplete(form, card);
  }

  function isEnhancementStale(form) {
    var card = form.querySelector(ENHANCED_MARKER);
    if (!card) return false;
    var fieldsWrapper = form.querySelector('.la-fields-wrapper') || form;
    if (!fieldsWrapper.contains(card)) return true;
    if (card.dataset.ciwLaContactLayout && card.dataset.ciwLaContactLayout !== getContactLayoutMode(form)) {
      return true;
    }
    var hasDesktopGrid = !!card.querySelector('.ciw-la-rx-grid--contact-desktop');
    var hasMobileBlocks = !!card.querySelector('.ciw-la-rx-eye-block--od');
    var expectsDesktopGrid = getContactLayoutMode(form) === 'desktop-toric-grid';
    if (expectsDesktopGrid && !hasDesktopGrid) {
      return true;
    }
    if (!expectsDesktopGrid && hasDesktopGrid) {
      return true;
    }
    if (isMobile() && hasDesktopGrid) {
      return true;
    }
    if (isContactGridComplete(card)) return false;
    var desktopGrid = card.querySelector('.ciw-la-rx-grid--contact-desktop');
    if (desktopGrid) {
      return countEyeControls(desktopGrid) === 0;
    }
    var odCount = countEyeControls(card.querySelector('.ciw-la-rx-eye-block--od'));
    var osCount = countEyeControls(card.querySelector('.ciw-la-rx-eye-block--os'));
    return odCount === 0 && osCount === 0;
  }

  function resetEnhancement(form) {
    delete form.dataset.ciwLaContactEnhanced;
    form.querySelectorAll(ENHANCED_MARKER).forEach(function (node) {
      if (node.__ciwLaRestoreMap) {
        restoreItemsFromCard(node, node.__ciwLaRestoreMap);
      }
      node.remove();
    });
    form.classList.remove(
      'ciw-la-contact-rx-form',
      'ciw-la-contact-rx-form--mobile',
      'ciw-la-contact-upload-form--mobile'
    );

    var contentBody = form.closest('.la-prescription-modal-content-body');
    if (contentBody) {
      contentBody.classList.remove('ciw-la-contact-rx-step', 'ciw-la-contact-rx-step--mobile');
    }
  }

  function hideStaleNativeRxForUpload(form) {
    if (!form) return;

    form.querySelectorAll('.la-right-rx-container, .la-left-rx-container').forEach(hideNativeContactElement);

    form.querySelectorAll('.la-prescription-fields-wrapper').forEach(function (wrapper) {
      if (wrapper.closest('.la-upload-wrapper, .ciw-la-contact-rx-card')) return;
      if (isEnhancedContactRxNode(wrapper)) return;
      if (wrapper.querySelector('.la-form-item[key]')) {
        hideNativeContactElement(wrapper);
      }
    });

    form.querySelectorAll('.ciw-la-manual-rx-heading').forEach(hideElement);
  }

  function revealUploadElements(form) {
    if (!form) return;

    var selectors = [
      '.la-upload-wrapper',
      '[data-la-scan-box]',
      '.la-scan-box-wrapper',
      '.la-barcode-scan-wrapper',
      '.ciw-la-contact-scan'
    ];

    selectors.forEach(function (selector) {
      form.querySelectorAll(selector).forEach(revealElement);
    });
  }

  function revealNativeContactUploadForm(form) {
    if (!form) return;

    form.querySelectorAll('.ciw-la-manual-rx-hidden').forEach(function (node) {
      if (node.closest('.ciw-la-contact-rx-card')) return;
      revealElement(node);
    });

    var fieldsWrapper = form.querySelector('.la-fields-wrapper');
    if (fieldsWrapper) {
      Array.from(fieldsWrapper.children).forEach(function (child) {
        if (child.classList.contains('ciw-la-contact-rx-card')) return;
        revealElement(child);
      });
    }
  }

  function prepareContactUploadStep(form) {
    if (form.querySelector(ENHANCED_MARKER) || form.classList.contains('ciw-la-contact-rx-form--mobile')) {
      resetEnhancement(form);
    }

    setContactNativeSuppressed(form, false);
    setContactEnhancePending(form, false);
    setContactReady(form, false);

    form.classList.remove('ciw-la-contact-rx-form', 'ciw-la-contact-rx-form--mobile');

    hideStaleNativeRxForUpload(form);

    var contentBody = form.closest('.la-prescription-modal-content-body');
    if (contentBody) {
      contentBody.classList.remove('ciw-la-contact-rx-step', 'ciw-la-contact-rx-step--mobile');
    }

    form.classList.add('ciw-la-contact-upload-form--mobile');
    revealNativeContactUploadForm(form);
    revealUploadElements(form);
    placeContactUploadFormTail(form);
    scheduleUploadTailRetries(form);
    ensureContactFooter();
    stopContactFooterWatch();
  }

  function finalizeContactManualCard(form, card, fieldsWrapper) {
    hideScanElements(form);
    placeContactFormTail(form, card, fieldsWrapper);
    hideNativeContactRxContainers(form, card);
    revealContactCardContents(card);
    syncContactEyeBlocks(form);
    ensureContactFooter();
    ensureContactValidationUi(form);
    syncContactReadyState(form, card);
    scheduleSameRxPlacementRetries(form);
  }

  function maintainContactManualEnhancement(form, card, fieldsWrapper) {
    placeContactFormTail(form, card, fieldsWrapper);
    hideNativeContactRxContainers(form, card);
    syncContactEyeBlocks(form);
    ensureContactFooter();
    ensureContactValidationUi(form);
    syncContactReadyState(form, card);
    if (isContactEnhancementComplete(form, card)) {
      document.dispatchEvent(new CustomEvent('ciw-la-contact-rx:enhanced'));
    }
  }

  function enhanceContactRxForm() {
    if (!isContactHost() || !document.body.classList.contains('la-modal-open')) return;
    if (contactLaActiveStep === 'upload') return;
    if (!isContactFormStep()) return;
    if (enhanceInFlight) return;

    var form = getContactForm();
    if (!form) return;
    if (form.classList.contains('ciw-la-manual-rx-form--mobile')) return;

    enhanceInFlight = true;
    pauseFormMutationObserver();

    if (isContactUploadStep(form)) {
      prepareContactUploadStep(form);
      enhanceInFlight = false;
      resumeFormMutationObserver(form);
      return;
    }

    if (!isContactManualEntryStep(form)) {
      setContactNativeSuppressed(form, false);
      setContactReady(form, false);
      setContactEnhancePending(form, false);
      enhanceInFlight = false;
      resumeFormMutationObserver(form);
      return;
    }

    ensureContactFooter();
    form.classList.remove('ciw-la-contact-upload-form--mobile');
    beginContactManualEntry(form);

    var fieldsWrapper = form.querySelector('.la-fields-wrapper') || form;
    var existingCard = form.querySelector(ENHANCED_MARKER);
    if (existingCard) {
      if (existingCard.dataset.ciwLaContactLayout && existingCard.dataset.ciwLaContactLayout !== getContactLayoutMode(form)) {
        resetEnhancement(form);
        beginContactManualEntry(form);
      } else if (isEnhancementStable(form)) {
        maintainContactManualEnhancement(form, existingCard, fieldsWrapper);
        enhanceInFlight = false;
        resumeFormMutationObserver(form);
        return;
      } else if (!isEnhancementStale(form)) {
        maintainContactManualEnhancement(form, existingCard, fieldsWrapper);
        enhanceInFlight = false;
        resumeFormMutationObserver(form);
        return;
      } else {
        resetEnhancement(form);
        beginContactManualEntry(form);
      }
    }

    var eyes = findEyeContainers(form);
    if (!eyes) {
      enhanceInFlight = false;
      resumeFormMutationObserver(form);
      return;
    }

    var rightItems = getRxItems(eyes.right);
    var leftItems = getRxItems(eyes.left);
    if (!eyeItemsAreReady(rightItems) || !eyeItemsAreReady(leftItems)) {
      enhanceInFlight = false;
      resumeFormMutationObserver(form);
      return;
    }

    var card = document.createElement('div');
    card.className = 'ciw-la-contact-rx-card ciw-la-manual-rx-card ciw-la-manual-rx-card--mobile';
    var restoreMap = new Map();
    card.__ciwLaRestoreMap = restoreMap;

    var heading = fieldsWrapper.querySelector('.ciw-la-manual-rx-heading');
    if (!heading) {
      heading = buildContactHeading();
      fieldsWrapper.insertBefore(heading, fieldsWrapper.firstChild);
    }
    revealElement(heading);

    var rxSection = document.createElement('div');
    rxSection.className = 'ciw-la-manual-rx-section ciw-la-manual-rx-section--rx';
    rxSection.appendChild(buildContactRxStack(rightItems, leftItems, restoreMap));
    card.appendChild(rxSection);

    if (!isContactGridComplete(card)) {
      restoreItemsFromCard(card, restoreMap);
      enhanceInFlight = false;
      resumeFormMutationObserver(form);
      return;
    }

    form.dataset.ciwLaContactEnhanced = '1';
    card.dataset.ciwLaContactLayout = getContactLayoutMode(form);

    var contentBody = form.closest('.la-prescription-modal-content-body');
    if (contentBody) {
      contentBody.classList.add('ciw-la-contact-rx-step', 'ciw-la-contact-rx-step--mobile');
    }

    hideElement(form.querySelector('.la-wrapper-heading'));
    hideElement(form.querySelector('.la-patient-name-wrapper'));

    fieldsWrapper.querySelectorAll('.la-divider').forEach(hideElement);

    hideElement(eyes.right);
    hideElement(eyes.left);

    if (heading.nextSibling !== card) {
      fieldsWrapper.insertBefore(card, heading.nextSibling);
    }

    finalizeContactManualCard(form, card, fieldsWrapper);

    form.classList.add('ciw-la-contact-rx-form', 'ciw-la-contact-rx-form--mobile');
    startContactFooterWatch();

    syncContactReadyState(form, card);
    if (isContactEnhancementComplete(form, card)) {
      document.dispatchEvent(new CustomEvent('ciw-la-contact-rx:enhanced'));
    }
    enhanceInFlight = false;
    resumeFormMutationObserver(form);
  }

  var formMutationObserver = null;
  var formMutationObserverTarget = null;
  var observerPaused = false;

  function mutationIsRelevant(record) {
    var target = record.target;
    if (!target || target.nodeType !== 1) return true;

    var form = getContactForm();
    var card = form ? form.querySelector(ENHANCED_MARKER) : null;
    if (card && form && !isContactEnhancementComplete(form, card)) {
      if (target.closest && target.closest('.ciw-la-contact-rx-card')) return true;
      if (target.classList && target.classList.contains('ciw-la-contact-rx-card')) return true;
    }

    if (target.closest && target.closest('.ciw-la-contact-rx-card')) return false;
    if (target.classList && target.classList.contains('ciw-la-contact-rx-card')) return false;
    return true;
  }

  function pauseFormMutationObserver() {
    observerPaused = true;
    if (formMutationObserver) {
      formMutationObserver.disconnect();
    }
  }

  function resumeFormMutationObserver(form) {
    observerPaused = false;
    if (!form || !formMutationObserver || formMutationObserverTarget !== form) return;
    formMutationObserver.observe(form, { childList: true, subtree: true });
  }

  function watchContactFormRender(form) {
    if (!form || form.dataset.ciwLaContactWatch === '1') return;
    if (typeof MutationObserver === 'undefined') return;

    form.dataset.ciwLaContactWatch = '1';
    formMutationObserverTarget = form;
    formMutationObserver = new MutationObserver(function (records) {
      if (observerPaused || enhanceInFlight) return;

      var formNode = getContactForm();
      if (formNode) {
        var cardNode = formNode.querySelector(ENHANCED_MARKER);
        if (
          cardNode &&
          !isContactSameRxPlaced(formNode) &&
          (contactGraduationSourceExists(formNode) || findSameRxCheckbox(formNode))
        ) {
          var fieldsWrapperNode = formNode.querySelector('.la-fields-wrapper') || formNode;
          ensureContactSameRxPlaced(formNode, cardNode, fieldsWrapperNode);
          hideNativeContactRxContainers(formNode, cardNode);
          syncContactEyeBlocks(formNode);
          syncContactReadyState(formNode, cardNode);
        }
      }

      if (formNode && isEnhancementStable(formNode)) {
        return;
      }

      var hasRelevantMutation = records.some(mutationIsRelevant);
      if (!hasRelevantMutation) return;

      scheduleEnhance(false);
    });
    formMutationObserver.observe(form, { childList: true, subtree: true });
  }

  var enhancePassTimer = null;
  var enhanceInFlight = false;

  function runEnhancePasses(forceFullPass) {
    enhanceContactRxForm();

    if (!forceFullPass) return;

    window.setTimeout(function () {
      var currentForm = getContactForm();
      if (!currentForm || !document.body.classList.contains('la-modal-open') || !isContactManualEntryStep(currentForm)) {
        return;
      }

      if (isEnhancementStable(currentForm)) {
        return;
      }

      var card = currentForm.querySelector(ENHANCED_MARKER);
      var fieldsWrapper = currentForm.querySelector('.la-fields-wrapper') || currentForm;
      if (card) {
        maintainContactManualEnhancement(currentForm, card, fieldsWrapper);
      } else {
        enhanceContactRxForm();
      }
    }, 300);
  }

  function scheduleEnhance(forceFullPass) {
    var form = getContactForm();
    if (form) watchContactFormRender(form);

    if (form && isEnhancementStable(form) && !forceFullPass) {
      if (enhancePassTimer) {
        window.clearTimeout(enhancePassTimer);
        enhancePassTimer = null;
      }
      enhanceContactRxForm();
      return;
    }

    if (enhancePassTimer) {
      window.clearTimeout(enhancePassTimer);
    }

    enhancePassTimer = window.setTimeout(function () {
      enhancePassTimer = null;
      runEnhancePasses(!!forceFullPass);
    }, forceFullPass ? 16 : 120);
  }

  function handleContactManualEntryRender() {
    contactLaActiveStep = 'manual';
    var form = getContactForm();
    beginContactManualEntry(form);
    scheduleEnhance(true);
    scheduleSameRxPlacementRetries(form);
  }

  function handleContactUploadRender() {
    contactLaActiveStep = 'upload';
    var form = getContactForm();
    if (form) {
      setContactNativeSuppressed(form, false);
      setContactEnhancePending(form, false);
      setContactReady(form, false);
    }
    if (window.ciwLaContactUploadEnhance) {
      window.ciwLaContactUploadEnhance();
    }
  }

  function handleContactModalClose() {
    contactLaActiveStep = null;
    stopContactFooterWatch();
    disconnectSameRxTextObserver();
    clearContactManualRxContentBodyPendingHide();
    var form = getContactForm();
    if (!form) return;
    resetContactRxSubmitAttempt(form);
    setContactNativeSuppressed(form, false);
    setContactReady(form, false);
    setContactEnhancePending(form, false);
  }

  function bind() {
    if (!isContactHost()) return;

    document.addEventListener('LensAdvizor:render:contactLensForm', handleContactManualEntryRender);
    document.addEventListener('LensAdvizor:render:manualEntryForm', function () {
      hideContactManualRxContentBodyForEnhance();
      handleContactManualEntryRender();
    });
    document.addEventListener('LensAdvizor:render:uploadForm', handleContactUploadRender);
    document.addEventListener('LensAdvizor:selectLensModal:open', function () {
      scheduleEnhance(true);
    });
    document.addEventListener('LensAdvizor:selectLensModal:close', handleContactModalClose);
    document.addEventListener('LensAdvizor:component:DidMount', function (event) {
      var detail = event && event.detail ? event.detail : {};
      if (detail.method === 'renderManualEntryForm' || detail.method === 'renderContactLensForm') {
        handleContactManualEntryRender();
        return;
      }
      if (detail.method === 'renderUploadForm') {
        handleContactUploadRender();
      }
    });

    document.addEventListener('click', function (event) {
      if (
        event.target.closest(
          '#submission-type-0, .la-submission-type-0, [data-submission-type="upload"], [data-submission-type="uploaded"], .la-submission-type-upload, .la-submission-type-uploaded, .la-upload-prescription, [data-submission-type="scan"]'
        )
      ) {
        contactLaActiveStep = 'upload';
        window.setTimeout(handleContactUploadRender, 0);
        return;
      }

      if (
        event.target.closest(
          '.la-canEnterPrescriptionManually, #submission-type-1, .la-submission-type-1, .la-submission-type-manual, [data-submission-type="manual"], .la-manual-entry, .la-manual-prescription-entry'
        )
      ) {
        contactLaActiveStep = 'manual';
        beginContactManualEntry(getContactForm());
        window.setTimeout(handleContactManualEntryRender, 0);
      }
    });

    if (typeof MQ_MOBILE.addEventListener === 'function') {
      MQ_MOBILE.addEventListener('change', function () {
        scheduleEnhance(true);
      });
    } else if (typeof MQ_MOBILE.addListener === 'function') {
      MQ_MOBILE.addListener(function () {
        scheduleEnhance(true);
      });
    }

    document.addEventListener('ciw-la-manual-rx:enhanced', function () {
      window.setTimeout(function () {
        syncContactEyeBlocks(getContactForm());
      }, 0);
    });
  }

  window.ciwLaContactStepMark = function (step) {
    contactLaActiveStep = step || null;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
